/*
 * ===============================================================================================================
 *                                Copyright 2022, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SAVE_USER_FORM_VALUES_INITIAL_STATE = {
  idpId: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  userName: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  displayName: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  givenName: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  lastName: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  email: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  mobilePhone: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  isMfaEnabled: {
    value: false,
    error: false,
    errorHelperText: ''
  },
  preferredMfa: {
    value: "",
    error: false,
    errorHelperText: ''
  },
  password: {
    value: '',
    error: false,
    errorHelperText: ''
  },
  preRegistration: {
    value: false,
    error: false,
    errorHelperText: ''
  }
};
